/**
 * Sticky product details: exposes the details block height as --vm-details-height so its sticky `top`
 * (blocks/_product-details.liquid) can switch from « stuck under the header » to « stuck by its bottom
 * edge » when the block is taller than the screen (e.g. engraving panel open).
 */
const SELECTOR = '#MainContent .product-details.sticky-content--desktop';

const observer = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const element = /** @type {HTMLElement} */ (entry.target);
    element.style.setProperty('--vm-details-height', `${Math.ceil(element.getBoundingClientRect().height)}px`);
  }
});

/** @type {WeakSet<Element>} */
const observed = new WeakSet();

function observeDetails() {
  for (const element of document.querySelectorAll(SELECTOR)) {
    if (observed.has(element)) continue;
    observed.add(element);
    observer.observe(element);
  }
}

observeDetails();
// Theme editor re-renders the section with a new details element
document.addEventListener('shopify:section:load', observeDetails);
